export default {
  orders: '',
  details: '/detalle/:id/:restaurant',
  recieve: '/recibir/:id/:restaurant',
  confirmation: '/confirmacion/:id/:restaurant',
  newOrder: '/nueva',
};
